const STORAGE_KEY = 'lavsan_cookie_consent';
const CONSENT_EVENT = 'lavsan:cookie-consent';

export function getCookieConsent() {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(STORAGE_KEY);
  if (value === 'all' || value === 'essential') return value;
  return null;
}

export function setCookieConsent(value) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, value);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { value } }));
}

export function resetCookieConsent() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { value: null } }));
}

export function subscribeCookieConsent(listener) {
  if (typeof window === 'undefined') return () => {};
  const handler = (event) => listener(event?.detail?.value ?? getCookieConsent());
  window.addEventListener(CONSENT_EVENT, handler);
  return () => window.removeEventListener(CONSENT_EVENT, handler);
}

export function hasAnalyticsConsent() {
  return getCookieConsent() === 'all';
}
